export default {
  variable_percentual: "Percentual Variável",
  fixed_percentage: "Percentual Fixo",
  fixed_value: "Valor Fixo",
  variable_value: "Valor Variável"
};



// WEBPACK FOOTER //
// ./src/core/enum/discount-type-values.enum.js